const SHOW_MYLIST = 'flixfrenzy/redux/SHOW_MYLIST';

// eslint-disable-next-line default-param-last
const showMyListReducer = (state = { showList: false }, action) => {
  switch (action.type) {
    case SHOW_MYLIST:
      return action.payload;
    default:
      return state;
  }
};

export const showMyList = (showMyListState) => (dispatch) => {
  dispatch({
    type: SHOW_MYLIST,
    payload: showMyListState,
  });
};

export default showMyListReducer;
